import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import "@/assets/styles/_globals.scss";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
    faPhone,
    faScaleBalanced,
    faAddressCard,
    faLocationDot,
    faEnvelope,
    faCircleCheck,
    faCar,
    faTrainSubway,
    faWheelchair,
    faPaperPlane,
    faPhoneVolume,
    faHouse,
    faCircleXmark,
    faBars,
    faXmark

} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import './assets/tailwind.css'
import { createHead } from "@vueuse/head";
import VueGTag from 'vue-gtag';

library.add(
    faBars,
    faXmark,
    faCircleXmark,
    faCircleCheck,
    faCar,
    faTrainSubway,
    faPhone,
    faScaleBalanced,
    faPhoneVolume,
    faHouse,
    faEnvelope,
    faLocationDot,
    faAddressCard,
    faPaperPlane,
    faWheelchair
);

const head = createHead();
head.push({
    htmlAttrs: {
        lang: 'de'
    }
});

createApp(App)
  .component("font-awesome-icon", FontAwesomeIcon)
  .use(router)
  .use(head)
    .use(VueGTag, {
        pageTrackerScreenviewEnabled: true,
        config: {
            id: "G-YL9KQP7LXB",
            params: {
                app_name: 'Lautstark' // GA4 Standard-Parameter
            }
        }
    }, router)
  .mount("#app");
